import { Link } from "react-router-dom";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-2xl mx-auto px-6 py-16 flex flex-col gap-8">
        <div className="flex flex-col items-center gap-2 text-center">
          <img src="/icon_animate.svg" alt="BOO" className="w-16 h-16" />
          <h1 className="text-2xl font-bold text-foreground font-sans">
            BOO Expense Tracker
          </h1>
          <p className="text-muted-foreground text-sm">
            Personal finance tracker with Thai tax planning
          </p>
        </div>

        <div className="flex flex-col gap-4 text-foreground font-sans">
          <p>
            BOO Expense Tracker helps you track day-to-day spending, import
            bank statements and QR slips automatically, and plan your Thai
            personal income tax across the year.
          </p>
          <ul className="list-disc list-inside flex flex-col gap-1 text-sm text-muted-foreground">
            <li>Monthly spending summary with category breakdown</li>
            <li>Automatic bank statement import via Gmail</li>
            <li>QR payment slip upload and parsing</li>
            <li>Thai income tax planner with deductions and brackets</li>
            <li>Recurring income and expense tracking</li>
          </ul>
        </div>

        <div className="flex items-center gap-4 text-sm">
          <Link
            to="/login"
            className="text-foreground underline hover:no-underline"
          >
            Sign in
          </Link>
          <Link
            to="/privacy-policy"
            className="text-muted-foreground underline hover:no-underline"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
}
